import { render, staticRenderFns } from "./GameSetup.vue?vue&type=template&id=406af8e8"
import script from "./GameSetup.vue?vue&type=script&lang=js"
export * from "./GameSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports